
import { ReactNode } from "react";

interface SubjectLineProps {
  children: ReactNode;
}

const SubjectLine = ({ children }: SubjectLineProps) => {
  return (
    <div className="font-medium text-lg mb-3">
      {children}
    </div>
  );
};

export default SubjectLine;
